import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { clearAuthToken } from '@noor/api';
import { sessionApi } from '@/entities/session';

export function useSignOut() {
  const queryClient = useQueryClient();
  const router = useRouter();

  return async function signOut() {
    await sessionApi.logout();
    clearAuthToken();
    queryClient.clear();
    await router.navigate({ to: '/login' });
  };
}
